import React from 'react'
import {Link} from 'gatsby'

import Layout from '../components/layouts/layout'
import useCarousel from '../hooks/use-carousel'
import {ShowcaseSelect, ShowcaseCarousel, ShowcaseSelectGroup, ShowcaseSlide} from '../components/showcase'
import Button8 from '../components/button8'
import {combine} from '../styles/classname-utils'
import webGearsImg from '../../img/web-gears.svg'
import faceEffectsForWebVideo from '../../img/vids/engine-features/face-effects-for-web.mp4'
import engineWorldTrackingImg from '../../img/vids/engine-features/engine-world-tracking-for-web.mp4'
import lightshipVpsForWebVideo from '../../img/vids/engine-features/lightship-vps-for-web.mp4'
import engineImageTargetsVideo from '../../img/vids/engine-features/engine-image-targets-noportal-forweb.mp4'
import engineModularFrameworkVideo from '../../img/vids/engine-features/engine-modular-framework-for-web.mp4'
import faceEffectsForWebVideoCover from '../../img/vids/engine-features/face-effects-for-web.jpg'
import engineWorldTrackingImgCover from '../../img/vids/engine-features/engine-world-tracking-for-web.jpg'
import lightshipVpsVideoCover from '../../img/vids/engine-features/lightship-vps-for-web.jpg'
import engineImageTargetsVideoCover from '../../img/vids/engine-features/engine-image-targets-noportal-forweb.jpg'
import engineModularFrameworkVideoCover from '../../img/vids/engine-features/engine-modular-framework-for-web.jpg'
import editorNoConsoleImg from '../../img/editor-screens/editor-no-console.jpg'
import editorWithConsoleImg from '../../img/editor-screens/editor-with-console.jpg'
import templatesImg from '../../img/editor-screens/templates.jpg'
import publishModalImg from '../../img/editor-screens/publish-modal.jpg'
import scanToPreviewImg from '../../img/editor-screens/scan-to-preview.jpg'
import reviewSyncConflictImg from '../../img/editor-screens/review-sync-conflict.jpg'
import teamManagerImg from '../../img/editor-screens/team-manager.jpg'
import projectHistoryImg from '../../img/editor-screens/project-history-3x.jpg'
import clientManagementImg from '../../img/editor-screens/client-management.jpg'
import globalWebHostingImg from '../../img/editor-screens/global-web-hosting.jpg'
import customDomainImg from '../../img/editor-screens/custom-domain.jpg'
import sharingScreenImg from '../../img/editor-screens/sharing-screen.jpg'
import aframeLogo from '../../img/engines/aframe.png'
import threeJsLogo from '../../img/engines/threejs.png'
import babylonLogo from '../../img/engines/babylon.png'
import playCanvasLogo from '../../img/engines/playcanvas.png'
import classes from './products-web.module.scss'
import DeviceDeploySection from '../components/device-deploy-section'
import DotyDemoHero from '../components/doty-demo-hero'

export default () => {
  const [select, slide] = useCarousel(1)
  const [collabSelect, collabSlide] = useCarousel(1)
  const [publishSelect, publishSlide] = useCarousel(1)
  const pageTitle = 'Features'
  const pageSubTitle = 'Use 8th Wall to build immersive WebAR experiences' +
    ' that work on every mobile device. No app required.'
  return (
    <Layout
      title='Product - WebAR SDK for World Tracking, Face Effects, Image Targets, Inline AR'
      description='8th Wall’s powerful augmented reality SDK is hyper-optimized for the browser and works across all devices. Develop WebAR projects with World Tracking, Face Effects, Image Targets and more.'
    >
      <DotyDemoHero title={pageTitle} subtitle={pageSubTitle} />

      <section className={classes.engineFeatureContainer}>
        <h2 className={combine('h2-xl', classes.sectionHeading)}>
          <img src={webGearsImg} alt='gears' /> AR Engine
        </h2>

        <div className={combine('row', classes.engineFeatureSection)} id='world-effects'>
          <div className='col-md-6 col-sm-12'>
            <video
              autoPlay
              loop
              muted
              playsInline
              src={engineWorldTrackingImg}
              poster={engineWorldTrackingImgCover}
            />
          </div>
          <div className={combine('col-md-6 col-sm-12', classes.rightSubSection)}>
            <h2>World Effects</h2>
            <p className='text8-lg'>
              Built entirely using standards-compliant JavaScript and WebGL, 8th Wall’s Simultaneous
              Localization and Mapping (SLAM) engine is hyper-optimized for real-time AR on mobile
              browsers. Features include Six Degrees of Freedom (6-DoF), Lighting estimation,
              instant surface detection and responsive scale.
            </p>
          </div>
        </div>

        <div className={combine('row', classes.engineFeatureSection)} id='lightship-vps'>
          <div className='order-sm-0 order-md-1 col-md-6 col-sm-12'>
            <video
              autoPlay
              loop
              muted
              playsInline
              src={lightshipVpsForWebVideo}
              poster={lightshipVpsVideoCover}
            />
          </div>
          <div
            className={combine('order-sm-1 order-md-0 col-md-6 col-sm-12', classes.leftSubSection)}
          >
            <h2>Lightship VPS for Web</h2>
            <p className='text8-lg'>
              Lightship VPS for Web uses Niantic’s AR map of the world to anchor WebAR content with
              centimeter-level precision at locations worldwide. Add VPS-activated locations to the map,
              or immediately make use of over 100,000 VPS-activated locations, to build location-based AR
              experiences that work in the browser. Lightship VPS for Web also gives access to the 3D mesh of a
              location enabling occlusion and physics and a greater level of interactivity between virtual
              objects and the physical world.
            </p>
          </div>
        </div>

        <div className={combine('row', classes.engineFeatureSection)} id='image-target'>
          <div className='col-md-6 col-sm-12'>
            <video
              autoPlay
              loop
              muted
              playsInline
              src={engineImageTargetsVideo}
              poster={engineImageTargetsVideoCover}
            />
          </div>
          <div
            className={combine('col-md-6 col-sm-12', classes.rightSubSection)}
          >
            <h2>Image Targets</h2>
            <p className='text8-lg'>
              Bring signage, magazines, boxes, bottles, cups, and cans to life with 8th Wall Image
              Targets. Upload and manage flat, cylindrical and conical shaped image targets to
              create web-based augmented reality experiences that are activated by and can track
              directly to the target. Image targets can work in tandem with our World Tracking,
              enabling experiences that combine image targets and markerless tracking.
            </p>
          </div>
        </div>

        <div className={combine('row', classes.engineFeatureSection)} id='face-effect'>
          <div className='order-sm-0 order-md-1 col-md-6 col-sm-12'>
            <video
              autoPlay
              loop
              muted
              playsInline
              src={faceEffectsForWebVideo}
              poster={faceEffectsForWebVideoCover}
            />
          </div>
          <div className={combine('order-sm-1 order-md-0 col-md-6 col-sm-12', classes.leftSubSection)}>
            <h2>Face Effects</h2>
            <p className='text8-lg'>
              Create high quality face filters that utilize the full power of the open web and work
              everywhere. Anchor 3D objects such as glasses or jewelry to a variety of face
              attachment points. Render a face mesh instantly with our easy-to-use component library
              or design custom visual effects with shaders, materials and video. 8th Wall Face
              Effects can be experienced across all devices including mobile phones, tablets and
              desktops with no app required!
            </p>
          </div>
        </div>

        <div className={combine('row', classes.engineFeatureSection)} id='modular-framework'>
          <div className='col-md-6 col-sm-12'>
            <video
              autoPlay
              loop
              muted
              playsInline
              src={engineModularFrameworkVideo}
              poster={engineModularFrameworkVideoCover}
            />
          </div>
          <div className={combine('col-md-6 col-sm-12', classes.rightSubSection)}>
            <h2>Modular Framework</h2>
            <p className='text8-lg'>
              Our powerful camera application framework is designed to integrate with computer
              vision technologies (people occlusion, machine learning models, etc.) and external
              libraries (voice recognition, multi-player, analytics packages, location services,
              etc.) by managing the application lifecycle, orchestrating run loops, and providing
              the needed hooks for high throughput image processing within a web application.
            </p>
          </div>
        </div>
      </section>

      <DeviceDeploySection />

      <section className='light'>
        <h2 className={combine('h2-xl', classes.sectionHeading)}>
          <img src={webGearsImg} /> Cloud Editor + Built-In Hosting
        </h2>

        <div className={classes.cloudProduct}>
          <ShowcaseCarousel>
            <ShowcaseSlide img={editorNoConsoleImg} active={slide(1)}>
              <p className='text8-md'>
                Cloud-based text editor includes auto-complete, an asset viewer, developer keybindings
                and support for popular frameworks such as React and Vue.js.
              </p>
            </ShowcaseSlide>
            <ShowcaseSlide img={templatesImg} active={slide(2)}>
              <p className='text8-md'>
                Choose from a growing library of sample projects to quickly get started with 8th Wall.
              </p>
            </ShowcaseSlide>
            <ShowcaseSlide img={editorWithConsoleImg} active={slide(3)}>
              <p className='text8-md'>
                Wirelessly debug your code in real time with live console logs from multiple devices and
                send eval commands to test without reloading.
              </p>
            </ShowcaseSlide>
            <ShowcaseSlide img={scanToPreviewImg} active={slide(4)}>
              <p className='text8-md'>
                8th Wall’s automated build system compiles and minifies projects into a single optimized
                bundle, providing an instant preview of your most recent changes.
              </p>
            </ShowcaseSlide>
            <ShowcaseSlide img={publishModalImg} active={slide(5)}>
              <p className='text8-md'>
                The freedom to integrate with any external API or library such as Google Analytics,
                React, Vue.js, live map data, custom fonts and holographic video streaming.
              </p>
            </ShowcaseSlide>
          </ShowcaseCarousel>
          <div className={classes.showcaseSelectGroupContainer}>
            <h2>Create</h2>
            <ShowcaseSelectGroup>
              <ShowcaseSelect select={select(1)} active={slide(1)}>Fully-Featured Text Editor</ShowcaseSelect>
              <ShowcaseSelect select={select(2)} active={slide(2)}>Templates</ShowcaseSelect>
              <ShowcaseSelect select={select(3)} active={slide(3)}>Remote Debugger</ShowcaseSelect>
              <ShowcaseSelect select={select(4)} active={slide(4)}>Instant Preview</ShowcaseSelect>
              <ShowcaseSelect select={select(5)} active={slide(5)}>External Library Support</ShowcaseSelect>
            </ShowcaseSelectGroup>
          </div>
        </div>
        <div className={classes.cloudProduct}>
          <ShowcaseCarousel>
            <ShowcaseSlide img={reviewSyncConflictImg} active={collabSlide(1)}>
              <p className='text8-md'>
                Allows multiple people to work on the same project simultaneously, review incoming
                changes, resolve conflicts and view diffs before landing.
              </p>
            </ShowcaseSlide>
            <ShowcaseSlide img={teamManagerImg} active={collabSlide(2)}>
              <p className='text8-md'>
                Invite unlimited members to join your workspace, manage user roles and permissions, and
                stay up to date with their changes as you work.
              </p>
            </ShowcaseSlide>
            <ShowcaseSlide img={projectHistoryImg} active={collabSlide(3)}>
              <p className='text8-md'>
                Compare commits over time with a full diff view and current client status.
              </p>
            </ShowcaseSlide>
            <ShowcaseSlide img={clientManagementImg} active={collabSlide(4)}>
              <p className='text8-md'>
                Use clients for quick bug fixes, independent feature development or exploration.
              </p>
            </ShowcaseSlide>
          </ShowcaseCarousel>
          <div className={classes.showcaseSelectGroupContainer}>
            <h2>Collaborate</h2>
            <ShowcaseSelectGroup>
              <ShowcaseSelect select={collabSelect(1)} active={collabSlide(1)}>Source Control</ShowcaseSelect>
              <ShowcaseSelect select={collabSelect(2)} active={collabSlide(2)}>Team Management</ShowcaseSelect>
              <ShowcaseSelect select={collabSelect(3)} active={collabSlide(3)}>Commit History</ShowcaseSelect>
              <ShowcaseSelect select={collabSelect(4)} active={collabSlide(4)}>Code Isolation</ShowcaseSelect>
            </ShowcaseSelectGroup>
          </div>
        </div>

        <div className={classes.cloudProduct}>
          <ShowcaseCarousel>
            <ShowcaseSlide img={publishModalImg} active={publishSlide(1)}>
              <p className='text8-md'>
                Publish and rollback multiple deployment states instantly. Includes a password-protected
                staging environment.
              </p>
            </ShowcaseSlide>
            <ShowcaseSlide img={globalWebHostingImg} active={publishSlide(2)}>
              <p className='text8-md'>
                Backed by Amazon CloudFront, 8th Wall's global hosting service allows you to host your
                project right at the edge, where
                your users are, with low latency via 225+ points of presence globally.
              </p>
            </ShowcaseSlide>
            <ShowcaseSlide img={customDomainImg} active={publishSlide(3)}>
              <p className='text8-md'>
                Add a custom domain to your 8th Wall-hosted project, or allowed domains to your
                self-hosted project.
              </p>
            </ShowcaseSlide>
            <ShowcaseSlide img={sharingScreenImg} active={publishSlide(4)}>
              <p className='text8-md'>
                Easily generate QR codes, shortlinks, customizable embed buttons and edit project
                metadata from the dashboard.
              </p>
            </ShowcaseSlide>
          </ShowcaseCarousel>
          <div className={classes.showcaseSelectGroupContainer}>
            <h2>Publish</h2>
            <ShowcaseSelectGroup>
              <ShowcaseSelect select={publishSelect(1)} active={publishSlide(1)}>Deployment Management</ShowcaseSelect>
              <ShowcaseSelect select={publishSelect(2)} active={publishSlide(2)}>Global Web Hosting</ShowcaseSelect>
              <ShowcaseSelect select={publishSelect(3)} active={publishSlide(3)}>Custom Domains</ShowcaseSelect>
              <ShowcaseSelect select={publishSelect(4)} active={publishSlide(4)}>Sharing</ShowcaseSelect>
            </ShowcaseSelectGroup>
          </div>
        </div>
      </section>

      <section>
        <h2 className={classes.sectionHeading}>Support for Popular 3D Frameworks</h2>

        <div className={combine('row', classes.engineBoxContainer)}>

          <div className={classes.engineBox}>
            <img src={aframeLogo} className={classes.engineIcon} alt='a frame logo' />
          </div>

          <div className={classes.engineBox}>
            <img src={threeJsLogo} className={classes.engineIcon} alt='three JS Logo' />
          </div>

          <div className={classes.engineBox}>
            <img src={babylonLogo} className={classes.engineIcon} alt='babylon logo' />
          </div>

          <div className={classes.engineBox}>
            <img src={playCanvasLogo} className={classes.engineIcon} alt='play canvas logo' />
          </div>

        </div>

      </section>

      <section className='light'>
        <div className='row justify-content-center'>
          <h2>Get Started!</h2>
          <div className='col-12 text-center'>
            <Button8 className='mt-2 mb-lg-0 mb-3'>
              <Link className={classes.viewPlanAndPricingLinkOut} to='/pricing'>
                View plans and pricing
              </Link>
            </Button8>
          </div>

        </div>
      </section>
    </Layout>
  )
}
